import { Icon } from '@iconify/react'
import { useHistory } from 'react-router-dom'

import s from './_.module.css'

type Props = {
  totalResults: number
  pushElementToLocalStorage: (text: string) => void
  searchText: string
  assignments: Assignment[] | Item[]
  companyId: string
  closeDropdown: () => void
}

export const DocSearchList = ({
  totalResults,
  pushElementToLocalStorage,
  searchText,
  assignments,
  companyId,
  closeDropdown,
}: Props): JSX.Element | null => {
  const history = useHistory()

  if (totalResults === 0) return null

  return (
    <div className={s.itemsSearchResults}>
      <div className={s.itemsResultHeader}>Internal Docs ({totalResults})</div>
      <div className={s.itemsResultMenu}>
        {assignments?.slice(0, 3).map(item => {
          const itemTitle = item?.title
          const itemId = item?.id

          return (
            <button
              className={s.eachItemResult}
              key={itemId}
              onClick={() => {
                closeDropdown()
                pushElementToLocalStorage(itemTitle)
                window.open(`/${companyId}/items/${itemId}`, '_blank')
              }}
              data-id="us_listItem"
            >
              <Icon
                icon="lucide:file-text"
                width="1rem"
                height="1rem"
                className={s.icon}
              />
              <span className={s.itemResultName}>
                <div>{item?.title}</div>
              </span>
            </button>
          )
        })}
        <button
          className={s.viewallResult}
          onClick={() => {
            closeDropdown()
            history.push(
              `/projects/items?item_types=private_doc&search_title=${searchText}`
            )
          }}
          data-id="us_viewAllItems"
        >
          <span>View all Internal Docs&nbsp;</span>
          <Icon icon="lucide:arrow-right" width="1rem" height="1rem" />
        </button>
      </div>
    </div>
  )
}
